/*eslint-disable*/
import React, { useState } from "react";
import {
    Card,
    CardBody,
    Label,
    FormGroup,
    Row,
    Input,
    CardHeader,
    Col,
    Button,
    Container
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
// import SimpleHeader from "components/Headers/SimpleHeader.js";
// import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"
import CurrencyInput from 'react-currency-input-field';

export default function CreateKasbon() {
    const [alert, setAlert] = React.useState(null);
    const token = localStorage.token;
    let history = useHistory();
    const warehouseId = localStorage.warehouse;
    const username = localStorage.username;
    const [description, setDescription] = useState("");
    // const [tanggal, setTanggal] = useState("");
    const [judul, setJudul] = useState("");
    const [tenor, setTenor] = useState("")
    const [nominal, setNominal] = useState("")
    const [isSpinner, setIsSpinner] = useState(false);

    const handleSubmit = () => {
        setTimeout(() => { CreateKasbon() }, 2000);
        setIsSpinner(true);
    };


    const CreateKasbon = () => {

        if (!tenor || !judul || !description || !nominal || nominal > 1000000) {
            setGagalAlert("Form tidak boleh kosong dan Nominal tidak lebih dari Rp 1.000.000");
            setIsSpinner(false);

            return;
        }

        const headers = {
            Authorization: `Bearer ${token}`,
        };
        let data = {
            username: username,
            warehouse_id: parseInt(warehouseId),
            nominal_request: nominal,
            keterangan: description,
            judul: judul,
            tenor: tenor,
        };
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/cash-bon/save`, data, { headers })
            .then(function (response) {
                setIsSpinner(false);
                history.push("/mobile/kasbon/sukses")

            })
            .catch(function (error) {
                setGagalAlert(error.response.data.message);
                setIsSpinner(false);

            });
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const Nominal = (e) => {
        const value = e === undefined ? 'undefined' : e;
        setNominal(value || ' ');
    };

    return (
        <>
            {alert}
            {/* <SimpleHeader name="Buat Izin" parentName="Master" /> */}
            {isSpinner ? (
                <Container className="mt--10 pb-10 login-container">
                    <Row className="justify-content-center">
                        <Col lg="5" md="7">
                            <div className="d-flex flex-column align-items-center d-lg-none d-xl-none">
                                <img src={require("assets/img/theme/loadingmobile1.gif").default} style={{ textAlign: "center", height: "12rem", width: "12rem", paddingTop: "1rem" }} />
                            </div>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <>
                    <SimpleHeaderMobile to="/mobile/kasbon/page" />
                    <Container className="mt--6" fluid>
                        <Row>
                            <div className="col">
                                {/* <CardBody> */}
                                <Row md="12">
                                    <Col md="12">
                                        <Card className="bg-secondary shadow">
                                            <CardHeader className="bg-white border-0">
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <h2>Ajukan Pinjaman</h2>
                                                    <div style={{ textAlign: 'left' }} className="d-lg-block d-none">
                                                        <Link className="btn btn-link" to="/mobile/kasbon/page">
                                                            <i className="fa fa-arrow-circle-left fa-2x" />
                                                        </Link>
                                                    </div>
                                                </div>
                                            </CardHeader>
                                            <CardBody>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Judul</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                        name="deskripsi Item"
                                                        placeholder="Masukan Judul"
                                                        value={judul}
                                                        onChange={(e) => {
                                                            setJudul(e.target.value);
                                                        }}
                                                    />
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label
                                                        className="form-control-label"
                                                        for="exampleEmail"
                                                    >
                                                        Nominal
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <CurrencyInput
                                                        id="validation-example-2-field"
                                                        placeholder="Rp0"
                                                        // allowDecimals={false}
                                                        value={nominal}
                                                        onValueChange={Nominal}
                                                        className={`form-control`}
                                                        prefix={'Rp'}
                                                        step={10}
                                                    />
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Tenor</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="select"
                                                        value={tenor}
                                                        onChange={(e) => {
                                                            setTenor(e.target.value);
                                                        }}
                                                    >
                                                        <option value="">Pilih Tenor</option>
                                                        <option value="1">1 Bulan</option>
                                                        <option value="2">2 Bulan</option>
                                                    </Input>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <Label className="form-control-label">Keterangan</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        className="form-control-alternative"
                                                        rows="7"
                                                        type="textarea"
                                                        name="deskripsi Item"
                                                        placeholder="Masukan Keterangan"
                                                        value={description}
                                                        onChange={(e) => {
                                                            setDescription(e.target.value);
                                                        }}
                                                    />
                                                </FormGroup>

                                            </CardBody>
                                            <Button color="danger" onClick={() => handleSubmit()}>
                                                Simpan
                                            </Button>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>
                        </Row>
                    </Container>
                </>
            )}
        </>
    );
}
